import { Image, Transformation } from "cloudinary-react"
import PropTypes from "prop-types"
import { useCallback, useContext, useState } from "react"
import { FaLink } from "react-icons/fa6"
import { MdDeleteOutline } from "react-icons/md"
import { uploadThumbnail } from "~/actions/upload"
import EditIcon from "~/assets/Icons/edit-icon.svg"
import AppContext from "~/contexts/App"

import NewDeleteImageDialog from "~/dialogs/NewDeleteImage"
import NewFileUpload from "../NewFileUpload"
import PermissionsWrapper from "../PermissionsWrapper"

const NewThumbnailUpload = ({
  title,
  cloudinaryUploadPreset,
  onUpload,
  onDelete,
  value,
  className,
}) => {
  const [loading, setLoading] = useState(false)

  const [openDeleteDialog, setOpenDeleteDialog] = useState(false)

  const { openSnackBar } = useContext(AppContext)

  const onDrop = useCallback(
    (acceptedFiles) => {
      setLoading(true)
      uploadThumbnail(acceptedFiles[0], cloudinaryUploadPreset)
        .then((uploadRes) =>
          onUpload(
            {
              data: {
                ...uploadRes.data,
                original_filename: acceptedFiles[0].name,
              },
            },
            setLoading,
          ),
        )
        .catch((err) => {
          setLoading(false)
          console.error(err)
        })
    },
    [cloudinaryUploadPreset, onUpload],
  )
  const renderDeleteImage = () => {
    return (
      <button
        className="z-10 color-inherit absolute top-5 right-1 opacity-0 group-hover:opacity-100 transition-opacity duration-500"
        onClick={(e) => {
          e.stopPropagation()
          e.preventDefault()
          setOpenDeleteDialog(true)
        }}
      >
        <MdDeleteOutline className="w-5 h-5 my-0" color="red" />
      </button>
    )
  }

  const renderCopyImage = () => {
    return (
      <button
        className="z-10 color-inherit absolute top-5 left-1 opacity-0 group-hover:opacity-100 transition-opacity duration-500"
        onClick={(e) => {
          e.stopPropagation()
          e.preventDefault()
          navigator.clipboard.writeText(value?.url)
          openSnackBar({ message: "Image URL copied to clipboard" })
        }}
      >
        <FaLink className="w-5 h-5 my-0" color="white" />
      </button>
    )
  }

  return (
    <>
      <NewFileUpload
        title={title ? title : "Drop thumbnail here"}
        onDrop={onDrop}
        showLoading={loading}
        className={className}
      >
        {value?.public_id && (
          <div className="relative group">
            <PermissionsWrapper permissionGroup="admin">
              {renderDeleteImage()}
            </PermissionsWrapper>
            {renderCopyImage()}
            <PermissionsWrapper permissionGroup="admin">
              <div>
                <img
                  className="absolute top-0 right-0 left-0 m-auto bottom-0 opacity-100 group-hover:opacity-100 transition-opacity duration-500"
                  src={EditIcon}
                  alt="Edit thumbnail"
                />
              </div>
            </PermissionsWrapper>
            <Image
              publicId={value.public_id}
              style={{ verticalAlign: "bottom", width: "100%" }}
            >
              <Transformation crop="fill" gravity="auto" aspectRatio="16:9" />
            </Image>
          </div>
        )}
      </NewFileUpload>
      <NewDeleteImageDialog
        open={openDeleteDialog}
        closeDialog={() => setOpenDeleteDialog(false)}
        onDelete={onDelete}
      />
    </>
  )
}

NewThumbnailUpload.propTypes = {
  title: PropTypes.string,
  cloudinaryUploadPreset: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  onUpload: PropTypes.func,
  className: PropTypes.string,
  onDelete: PropTypes.func,
}

export default NewThumbnailUpload
